<div class="home">
    <div class="JoinOurProgram margins-section">
        <div class="tablet-flex">
            <div class="section1">
                <img src="{{urlBlobStorage}}Home/Images/ProgramadeTitanes.svg" class="img-section1">
                <h1> Únete a nuestro programa, aprende <span class="marketing-digital">Marketing Digital</span> y gana dinero.</h1>
                <div class="showmoreDesktop">
                    <img src="{{urlBlobStorage}}Home/Icos/Mouse.svg" width="20px">            
                    <h6>DESLIZA HACIA ABAJO PARA CONOCER MÁS</h6>
                </div>
            </div>
            <div class="section2">
                <img src="{{urlBlobStorage}}Home/Images/titanesJoinOurProgram.webp"  width="90%">
            </div>
        </div>
        <div class="section3">
            <h5>¡Postularme para Titán!</h5>
            <div class="form">
                <app-titans-form> </app-titans-form>
            </div>
            <div class="showmoreTablet">
                <img src="{{urlBlobStorage}}Home/Icos/Mouse.svg" width="20px">            
                <h6>DESLIZA HACIA ABAJO PARA CONOCER MÁS</h6>
            </div>
        </div>
    </div>
    <div class="caroueltestimonial margins-section">
        <div class="section1carousel">
            <img src="{{urlBlobStorage}}Home/Images/titanes-de-confianza-en-marketing-digital.webp"  width="100%">
        </div>
        <div class="section2carousel">
            <h2> Que dicen las personas sobre el programa de <span class="marketing-digital">titanes de confianza en marketing digital</span></h2>
            <img src="{{urlBlobStorage}}Home/Icos/Flechas-grises.svg" width="25px">     
            <app-testimonial-carousel> </app-testimonial-carousel>     
        </div>
    </div> 
    <div class="Whoaretitans margins-section">
        <div class="section1Whoaretitans">
            <h2>¿Quienes son <br>los <span class="whoare">Titanes de confianza en marketing digital</span>?</h2>
            <img src="{{urlBlobStorage}}Home/Images/Quienes-son-los-Titanes.webp" class="whoaretitans-tabletimg" width="90%">
            <p>Son jóvenes entre 18 a 25 años que se especializan en marketing digital y personal shopping con el respaldo de Gran 
                Titán. Se encargan de conectar a miles de colombianos a través de la publicación Recomendaciones de Confianza que les
                 brinda información acerca de los temas que importan en sus vidas.</p>
            <div class="btnViewallTitans">
                <button class="boton-verde">VER TODOS LOS TITANES</button>
            </div>
        </div>
        <div class="section2Whoaretitans">
            <img src="{{urlBlobStorage}}Home/Images/Quienes-son-los-Titanes.webp" class="whoaretitans-desktopimg" width="100%">
        </div>
    </div>
    <div class="discoverTheBenefits margins-section">
        <h2>¡Descubre beneficios para ti!</h2>
        <img src="{{urlBlobStorage}}Home/Icos/Flechas-azules.svg">    
    </div>
    <div class="discoverTheBenefitsContainer margins-section">
        <div class="section1-discoverTheBenefits">
            <div class="list-benefits">
                <img src="{{urlBlobStorage}}Home/Icos/experiencia-certificada.svg" width="100px"> 
                <div class="description-benefits">
                    <h2>Obtén experiencia certificada</h2>
                    <p>Destaca en el mercado laboral con la experiencia que te da Gran Titán.</p>
                </div>
            </div> 
            <div class="list-benefits">
                <img src="{{urlBlobStorage}}Home/Icos/Gana-dinero.svg" width="100px"> 
                <div class="description-benefits">
                    <h2>Gana dinero</h2>
                    <p>Promociona los productos y servicios de marcas reconocidas.</p>
                </div>
            </div> 
            <div class="list-benefits">
                <img src="{{urlBlobStorage}}Home/Icos/Ofrece-publicaciones-exclusivas.svg" width="100px"> 
                <div class="description-benefits">
                    <h2>Ofrece publicaciones exclusivas</h2>
                    <p>Distribuye publicaciones con contenidos y ofertas recomendadas.</p>
                </div>
            </div> 
            <div class="list-benefits">
                <img src="{{urlBlobStorage}}Home/Icos/app-de-marketing-exclusiva.svg" width="100px"> 
                <div class="description-benefits">
                    <h2>Usa nuestra app de marketing exclusiva para Titanes</h2>
                    <p>Trabaja con una plataforma hecha solo para Titanes y accede a un plan de premios por tu desempeño.</p>
                </div>
            </div> 
            <div class="list-benefits">
                <img src="{{urlBlobStorage}}Home/Icos/Maneja-un-sistema-de-marketing-exitoso.svg" width="100px"> 
                <div class="description-benefits">
                    <h2>Maneja un sistema de marketing exitoso</h2>
                    <p>Tendrás a tu disposición herramientas prácticas e intuitivas para trabajar.</p>
                </div>
            </div> 
        </div> 
        <div class="section2-discoverTheBenefits">
            <img src="{{urlBlobStorage}}Home/Images/MovilHome1.webp"  width="90%">
        </div>
    </div>
    <div class="postulate-btn">
        <button class="btn-postulate" (click)="scrollToTop()">¡POSTÚLATE COMO TITÁN!</button>
    </div>
    <div class="have-the-tta">
        <div class="section1-have-the-tta">
            <img src="{{urlBlobStorage}}Home/Images/MovilHome2.webp"class="front-image">
            <div class="section-have-the-tta-tablet">
                <h4>Ten a la mano</h4>
                <h3>la Titán App</h3>
                <h5>Una herramienta con</h5>
                <img src="{{urlBlobStorage}}Home/Icos/Flechas-grises.svg" width="35px" class="gray-arrow-haveTTA"> 
                <button class="btn-conocetta-have-the-tta-desktop">Conoce la Titán App</button>
            </div>
        </div>
        <div class="section2-have-the-tta">
            <h4>Ten a la mano</h4>
            <h3>la Titán App</h3>
            <h5>Una herramienta con</h5>
            <button class="btn-conocetta">Conoce la Titán App</button>
        </div>
    </div>
    <div class="btn-conocetta-tablet">
        <button class="btn-conocetta-have-the-tta-tablet">Conoce la Titán App</button>
    </div>
    <div class="list-icon margins-section">
        <div class="section1-list-icon">
            <div class="list-benefits">
                <img src="{{urlBlobStorage}}Home/Icos/Productos-y-contenidos.svg" width="100px"> 
                <div class="description-benefits2">
                    <h2>Productos y contenidos</h2>
                    <p>Atrae a más personas con material inspirador, edificante, emocionante y empoderante.</p>
                </div>
            </div> 
            <div class="list-benefits">
                <img src="{{urlBlobStorage}}Home/Icos/Tus-ganancias.svg" width="100px"> 
                <div class="description-benefits2">
                    <h2>Tus contactos en un solo lugar</h2>
                    <p>Gestiona tus contactos y conviértelos en clientes fácilmente.</p>
                </div>
            </div> 
            <div class="list-benefits">
                <img src="{{urlBlobStorage}}Home/Icos/Tus-contactos-en-un-solo-lugar.svg" width="100px"> 
                <div class="description-benefits2">
                    <h2>Mensajes personalizados</h2>
                    <p>Brinda una atención personalizada con los mensajes que diseñamos para ti.</p>
                </div>
            </div> 
        </div>
        <div class="section2-list-icon">
            <div class="list-benefits">
                <img src="{{urlBlobStorage}}Home/Icos/Calendario-de-actividades.svg" width="100px"> 
                <div class="description-benefits2">
                    <h2>Tus ganancias</h2>
                    <p>Haz seguimiento y transfiere tu dinero desde la app.</p>
                </div>
            </div> 
            <div class="list-benefits">
                <img src="{{urlBlobStorage}}Home/Icos/Mensajes-personalizados.svg" width="100px"> 
                <div class="description-benefits2">
                    <h2>Calendario de actividades</h2>
                    <p>Mapea todas tus actividades del mes desde tu celular.</p>
                </div>
            </div> 
            <div class="list-benefits">
                <img src="{{urlBlobStorage}}Home/Icos/Capacitaciones-mensuales.svg" width="100px"> 
                <div class="description-benefits2">
                    <h2>Capacitaciones mensuales</h2>
                    <p>Descubre en la app tips para potenciar tu labor como Titán.</p>
                </div>
            </div> 
        </div>
    </div>
    <div class="postulate-btn">
        <button class="btn-postulate" (click)="scrollToTop()">¡POSTÚLATE COMO TITÁN!</button>
    </div>
</div>
<div class="btn-flotante" (click)="scrollToTop()">
    <mat-icon>arrow_upward</mat-icon>
</div>